// extracted by mini-css-extract-plugin
export default {"fgBase":"#161719","header":"TicketCategoryGroup-rebranding-module__header___1GYw5"};